import React from "react";

function IconSuccess() {
  return (
    <svg width="15" viewBox="0 0 15 15">
      <defs>
        <style>{`.icon-success-1{fill:#47d340;}.icon-success-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}`}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g id="Error">
            <circle cx="7.5" cy="7.5" r="7.5" className="icon-success-1"></circle>
            <path d="M6.17 10.17L11.5 4.83" className="icon-success-2"></path>
            <path d="M3.5 7.5L4.79 8.79 6.09 10.09" className="icon-success-2"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default IconSuccess;
